module.exports = __webpack_public_path__ + "img/ring_y_skip_1_0@2x.a96eaf95.png";